<template>
	<div>
		<div class="row">
			<div class="col-8 mb-4"> 
				<h1 class="float-left" v-if="isNew && !node.id">{{ $t("add-node") }}</h1>
				<h1 class="float-left" v-else-if="loaded">
					{{ node.title }}
				</h1>
				<div class="skeleton midnight h32 w-half" v-else></div>
			</div>
			<div class="col-4 mb-4">
				<button class="btn btn-primary float-right ml-4 mb-1" @click="finishEditing" v-if="editing" 
                :disabled="!node.title ">
					{{ $t("save") }}
				</button>
				<button class="btn btn-primary float-right" @click="startEditing" v-else>
					{{ $t("edit") }}
				</button>
				<button class="btn btn-outline-danger float-right" @click="editing = false" v-if="editing && node.id">{{ $t("cancel") }}</button>
			</div>
		</div>
		<div class="row" v-if="error">
			<div class="col-12">
				<b-alert variant="danger" show>{{ error }}</b-alert>
			</div>
		</div>
        <!--div class="row">
            <Graph v-if="loaded"
                :hierarchy="node"
                wrapperStyle="top: 0px; bottom:0; left: 0; right: 0; overflow: hidden;"
                :zoomable="false"
                :draggable="false"
            ></Graph>
        </div-->
        <div class="row">
            <div class="col-12">
                <b-breadcrumb>
                    <b-breadcrumb-item 
                        v-for="node in path" 
                        :key="node.id" 
                        :active="node.parent_id == null && node.absolute_parent_id !== null"
                        :href="`/curriculum-mapping/node/${node.id}`">
                        {{ node.title }}
                    </b-breadcrumb-item>
                </b-breadcrumb>
            </div>
        </div>
		<div class="row mb-2">
			<div class="col-sm-12 col-lg-6 mb-2">
				<TextInput
					:label="$t('title')"
					v-model="node.title"
					v-if="editing"
				/>
               <template v-else-if="loaded">
                    <label class="font-bold">{{ $t("title") }}</label>
                    <p class="mb-0">
                        {{ node.title }}
                    </p>
               </template>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
            <div class="col-sm-12 col-lg-6 mb-2">
                <SelectInput 
                    v-if="editing"
                    v-model="node.curriculumcomponenttype_id"
                    :options="components"
                    optionLabel="title"
                    optionValue="id"
                    :label="$t('component')"
                    class="font-bold"
                >
                </SelectInput>
               <template v-else-if="loaded">
                <label class="font-bold">{{ $t("component") }}</label>
                    <p class="mb-2">
                        {{ component !== null ? component.title : $t('none')}}
                    </p>
               </template>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
		</div>
        <div class="row mb-4">
            <div class="col-12">
                <TextAreaInput
                    v-if="editing" 
                    v-model="node.note"
                    :label="$t('notes')" 
                    class="font-bold"
                />
                <template v-else-if="loaded">
                    <label class="font-bold">{{ $t("notes") }}</label>
                    <p class="mb-0">
                        {{ node.note ? node.note : $t('none')  }}
                    </p>
               </template>
				<div class="skeleton midnight h16 w-half" v-else></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
               <!-- START Add New Node-->
                <div class="card mb-2 mt-2" v-if="editing">
                    <h5 class="card-header">{{ $t('add-new-node') }}</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                            <TextInput 
                                v-model="newNode.title" 
                                :label="$t('title')" 
                                class="font-bold"
                            />
                            </div>
                            <div class="col-sm-12 col-lg-6">
                                <SelectInput 
                                    v-model="newNode.curriculumcomponenttype_id"
                                    :options="components" 
                                    optionLabel="title"
                                    optionValue="id"
                                    :label="$t('component')" 
                                    class="font-bold"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <TextAreaInput 
                                    v-model="newNode.note"
                                    :label="$t('notes')" 
                                    class="font-bold"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button 
                                    class="btn btn-outline-primary float-right"
                                    @click="newNode.parent_id=$route.params['node_id']; saveNode(newNode)"
                                >
                                    {{ $t('add-node') }}
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <h3 class="font-bold">{{ $t('learning-outcomes') }}</h3>
                                <LearningOutcomesMapper
                                    v-model="newNode.learningoutcomes"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Add New Node-->
                <Table   
                    :loading="!loaded"
                    :submitting="submitting"
                    :cols="[
                        { key: 'title', heading: $t('name'), size: 4 },
                        { key: 'curriculumcomponenttype_id', heading: $t('component'), size: 4,
                        cb: (node) => { return getComponentTitle(node.curriculumcomponenttype_id) } },
                        { key: 'note', heading: $t('notes'), size: 4 }
                    ]"
                    :data="node.children"
                    breakpoint="md"
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                    }"
                    :searchable="false"
                    :scrollPaginate="true"
                    @refresh="refresh"
                    @selectItem="node => $router.push(`/curriculum-mapping/node/${node.id}`)"
                >
                <template v-slot:header>
                    <div class="list-group-item">
                        <h2>{{  $t('nodes')}}</h2>
                    </div>
                </template>
                </Table>
                <LearningOutcomesMapper 
                    v-model="node.learningoutcomes"
                >
                    <template v-slot:label>
                        <h2>{{ $t('learning-outcomes') }}</h2>
                    </template>
                </LearningOutcomesMapper>
            </div>
        </div>
	</div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
//import Graph from "src/components/CurriculumMapping/Graph";


export default {
	components: {
        Table,
        LearningOutcomesMapper,
       // Graph
	},
	data: function () {
		return {
			error: null,
			loaded: false,
			editing: false,
            node: {
            	id: null,
            	title: null,
            	children: [],
                learningoutcomes: []
            },
            nodes:[],
            newNode: { },
            submitting: false,
            filters: {
				page: 1,
				page_size: 30,
				total: 0,
				search: '',
			},
            components: [],
            learningoutcomes:[],
            path: []
		};
	},
	mounted() {
        
        this.getComponents();
        this.getPath();
		if (this.isNew) {
			this.loaded = true;
			this.startEditing();
		} else {
            this.getOutcomes()
                .then(()=> {
                    this.getNode(this.$route.params["node_id"])
                })
                .catch(err => {
                    this.$log.error.call(this, err);
                });
		}
	},
	methods: {
		finishEditing () {
            this.$store.commit("showBlockingSpinner");
			this.saveNode(this.node,true);
		},
        startEditing() {
            this.editing = true;
        },
        saveNode(node, absolute = false) {
            
            if(absolute) node.parent_id = node.absolute_parent_id;
            node.learningoutcomes =  node.learningoutcomes.original;
			this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/save`, {
				method: "post",
				data: node
			})
			.then((res) => {
            	this.$store.commit("hideBlockingSpinner");
				if (res.status === "SUCCESS") {

					this.error = null;

					if(absolute){
                        this.editing = false;
                    } else {
                        this.editing = true;
                    }
                    this.loaded = true;

                    this.node = res.result;
                    this.getNode();
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "There was a problem saving the topic.";
					}
				}
			}).catch((error) => {
            	this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.error = "There was a problem saving the topic.";
			});
        },
        getNode(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/gethierarchy`, {
                method: 'post',
                data: {
                    id: this.$route.params["node_id"],
                }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.node = res.result[0];
                    this.loaded = true;
                    this.node.learningoutcomes = [...this.node.learningoutcomes.original,...this.node.learningoutcomes.linked]
                    this.node.learningoutcomes = this.learningoutcomes.filter(obj => this.node.learningoutcomes.includes(obj.id))
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        },
        refresh(filters) {
			this.filters = { ...this.filters, ...filters }
			this.getNode();
		},
        getComponents() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/list`, {
                method: 'post'
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.components = res.results;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
		},
        getOutcomes() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`, {
                method: 'POST',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching learning outcomes')
                this.learningoutcomes = res.results
            }).catch(err => {
                console.error(err);
                this.$log.error.call(this, err);
            })
        },
        getComponentTitle(id){
            if(this.components.filter(obj => id == obj.id).length>0){
                return this.components.filter(obj => id == obj.id)[0].title;
            }
            return null;
        },
        getPath(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listnodes`, {
                method: 'post',
                data: {
                    id:this.$route.params["node_id"]
                }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    if(res.results) this.path =res.results.filter( item => item.id == this.$route.params["node_id"])[0].path;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        }
	},
	computed: {
		isNew: function () {
			return !this.$route.params["node_id"];
		},
        component() {
             if(this.components && this.node.curriculumcomponenttype_id){
                return this.components.filter(obj => this.node.curriculumcomponenttype_id == obj.id);
            }
            return null;
        }
	},
};
</script>


